<!-- src/views/Portfolio.vue -->
<template>
  <v-container class="mt-n12" fluid style="background: linear-gradient(#052947, 30%, #587084, #9db5c9)">
    <!-- DESKTOP -->
    <v-row class="d-none d-lg-block mx-16 px-16 py-16">
      <v-col cols="12" class="text-left">
        <v-img v-if="false" cover width="70%" style="display: block; margin: auto;" src="@/assets/texts/portfolio.svg" />
        <span class="text-white text-h1 font-weight-bold" style="display:block; margin: auto; font-family: Montserrat !important;">
          {{ $t('portfolio.title') }}
        </span>
      </v-col>
    </v-row>

    <!-- MOBILE -->
    <v-row class="d-lg-none">
      <v-col cols="12" class="text-center">
        <v-img v-if="false" cover style="display: block; margin: auto;" src="@/assets/texts/portfolio.svg" />
        <span class="text-h4 text-white font-weight-bold" style="display:block; margin: auto; font-family: Montserrat !important;">
          {{ $t('portfolio.title') }}
        </span>
      </v-col>
    </v-row>

    <!-- DESKTOP - cards de produtos -->
    <div class="d-none d-lg-block">
      <v-row no-gutters justify="center" class="py-16">
        <!-- Reportlake -->
        <v-col cols="4" class="mx-6 px-6">
          <v-card class="rounded-xl">
            <v-img src="@/assets/portfolio/reportlake.png" height="250px" contain class="mx-4" />
          </v-card>

          <v-card-text class="text-h5 font-weight-light text-white">
            {{ $t('portfolio.reportlake.txt1') }}
          </v-card-text>

          <!-- link com i18n-t -->
          <v-card-text class="text-h5 font-weight-light text-white">
            {{ $t('portfolio.click') + ' ' }}
              <a
                :href="$t('portfolio.reportlake.txt2')"
                target="_blank"
                rel="noopener noreferrer"
                class="text--link"
              >
                {{ $t('portfolio.here') + ' ' }}
              </a>
            {{ $t('portfolio.more') + ' ' }}
          </v-card-text>
        </v-col>

        <!-- Atlas -->
        <v-col cols="4" class="mx-6 px-6">
          <v-card class="rounded-xl">
            <v-img src="@/assets/portfolio/atlas.png" height="250px" contain class="mx-4" />
          </v-card>
          <v-card-text class="text-h5 font-weight-light text-white">
            {{ $t('portfolio.atlas') }}
          </v-card-text>
        </v-col>

        <!-- Ignoto -->
        <v-col cols="4" class="mx-6 px-6">
          <v-card class="assets-xl" style="background: black;">
            <v-img src="@/assets/portfolio/ignoto_branco.png" height="250px" contain class="mx-4" />
          </v-card>

          <!-- descrição com \n e pre-line -->
          <v-card-text class="text-h5 font-weight-light text-white" style="white-space: pre-line;">
            {{ $t('portfolio.ignoto.desc') }}
          </v-card-text>

          <!-- link com i18n-t -->
          <v-card-text class="text-h5 font-weight-light text-white">
            {{ $t('portfolio.click') + ' ' }}
              <a
                :href="$t('portfolio.ignoto.txt2')"
                target="_blank"
                rel="noopener noreferrer"
                class="text--link"
              >
                {{ $t('portfolio.here') + ' ' }}
              </a>
            {{ $t('portfolio.more') + ' ' }}
          </v-card-text>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE - cards de produtos -->
    <v-row no-gutters justify="center" class="d-lg-none">
      <!-- Reportlake -->
      <v-col cols="12">
        <v-card class="rounded-xl mt-8">
          <v-img src="@/assets/portfolio/reportlake.png" contain class="mx-2" />
        </v-card>
        <v-card-text class="font-weight-medium text-white">
          {{ $t('portfolio.reportlake.txt1') }}
        </v-card-text>
        <v-card-text class="text-center font-weight-medium text-white">
          <i18n-t keypath="portfolio.reportlake.txt2" tag="span">
            <template #link>
              <a
                href="https://reportlake.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="text--link"
              >
                {{ $t('common.here') }}
              </a>
            </template>
          </i18n-t>
        </v-card-text>
      </v-col>

      <!-- Atlas -->
      <v-col cols="12">
        <v-card class="rounded-xl mt-8">
          <v-img src="@/assets/portfolio/atlas.png" contain class="mx-2" />
        </v-card>
        <v-card-text class="font-weight-medium text-white">
          {{ $t('portfolio.atlas') }}
        </v-card-text>
      </v-col>

      <!-- Ignoto -->
      <v-col cols="12">
        <v-card class="rounded-xl mt-8 black">
          <v-img src="@/assets/portfolio/ignoto_branco.png" contain class="mx-2" />
        </v-card>
        <v-card-text class="font-weight-medium text-white" style="white-space: pre-line;">
          {{ $t('portfolio.ignoto.desc') }}
        </v-card-text>
        <v-card-text class="text-center font-weight-medium text-white">
            {{ $t('portfolio.click') + ' ' }}
              <a
                :href="$t('portfolio.ignoto.txt2')"
                target="_blank"
                rel="noopener noreferrer"
                class="text--link"
              >
                {{ $t('portfolio.here') + ' ' }}
              </a>
            {{ $t('portfolio.more') + ' ' }}
        </v-card-text>
      </v-col>
    </v-row>

    <!-- DESKTOP - parceiros -->
    <v-row class="d-none d-lg-block mx-16 px-16 py-16">
      <v-col cols="12">
        <span style="font-family: Montserrat !important;" class="text-white text-h1 font-weight-bold">
          {{ $t('portfolio.partners.title') }}
        </span>
      </v-col>
    </v-row>

    <!-- MOBILE - parceiros -->
    <v-row class="d-lg-none">
      <v-col cols="12" class="text-center">
        <span style="font-family: Montserrat !important;" class="text-white text-h4 font-weight-bold">
          {{ $t('portfolio.partners.title') }}
        </span>
      </v-col>
    </v-row>

    <!-- DESKTOP - grelha parceiros -->
    <div class="d-none d-lg-block">
      <v-row no-gutters justify="center">
        <v-col cols="2" class="ma-12" v-for="item in images" :key="item.path">
          <v-card
            class="rounded-xl transparent elevation-0"
            :style="item.background ? { background: item.background } : null"
          >
            <v-img
              v-if="item.link == null"
              :src="imagePath(item.path)"
              height="250px"
              contain
            />
            <v-img
              v-else
              style="cursor: pointer;"
              @click="connectPartner(item.link)"
              :src="imagePath(item.path)"
              height="250px"
              contain
            />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE - carrossel parceiros (Vuetify) -->
    <v-row class="ma-0 pa-0 d-lg-none">
      <v-col cols="12">
        <v-carousel
          v-model="carouselIndex"
          :cycle="true"
          :interval="3000"
          hide-delimiters
          height="320"
        >
          <v-carousel-item v-for="(i, index) in images" :key="index">
            <v-container
              fluid
              class="fill-height rounded-xl elevation-0 d-flex align-center justify-center"
              :style="i.background ? { background: i.background } : null"
            >
              <v-img
                :src="imagePath(i.path)"
                :alt="`partner-${index}`"
                contain
                max-width="300"
                max-height="300"
                v-on:click="connectPartner(i.link)"
                :style="i.link ? 'cursor: pointer;' : ''"
              />
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-col>

      <v-col cols="12" class="mt-n12 text-center ma-0 pa-0 mb-8">
        <v-btn class="mx-6" fab dark small color="primary" @click="goLeft">
          <v-icon dark color="white">mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn class="mx-6" fab dark small color="primary" @click="goRight">
          <v-icon dark color="white">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- DESKTOP - equipa -->
    <v-row class="d-none d-lg-block mx-16 px-16 py-16" id="team">
      <v-col cols="12" class="text-left">
        <v-img v-if="false" cover width="70%" style="display: block; margin: auto;" src="@/assets/texts/portfolio.svg" />
        <span class="text-white text-h1 font-weight-bold" style="display:block; margin: auto; font-family: Montserrat !important;">
          {{ $t('team.meet') }}
        </span>
      </v-col>
    </v-row>

    <!-- MOBILE - equipa -->
    <v-row class="d-lg-none" id="team2">
      <v-col cols="12" class="text-center">
        <v-img v-if="false" cover style="display: block; margin: auto;" src="@/assets/texts/portfolio.svg" />
        <span class="text-h4 text-white font-weight-bold" style="display:block; margin: auto; font-family: Montserrat !important;">
          {{ $t('team.meet') }}
        </span>
      </v-col>
    </v-row>

    <!-- DESKTOP TEAM BLOCKS -->
    <v-row class="d-none d-lg-block mt-16 mx-16 px-16">
      <v-col cols="12" md="12">
        <v-row no-gutters justify="center" class="py-16">
          <v-col cols="auto">
            <v-avatar style="margin: auto; display: block;" size="250px" class="elevation-16">
              <v-img :src="alvaroImg" alt="Avatar" cover />
            </v-avatar>
          </v-col>
          <v-col cols="8" class="ml-8 text-justify text-h5 text-white font-weight-bold" style="font-family: Montserrat !important;">
            <span class="font-italic">{{ $t('team.alvaro.text') }}</span><br /><br />
            <span class="font-weight-bold" style="color: #052A59; font-family: Montserrat !important; font-weight: bold !important;">
              {{ $t('team.alvaro.presentation') }}
            </span>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="12" class="mt-16 py-2">
        <v-row no-gutters justify="center">
          <v-col cols="8" class="ml-8 text-justify text-h5 text-white font-weight-bold" style="font-family: Montserrat !important;">
            <span class="font-italic">{{ $t('team.erbi.text') }}</span><br /><br />
            <span class="font-weight-bold" style="color: #052A59; font-family: Montserrat !important; font-weight: bold !important;">
              {{ $t('team.erbi.presentation') }}
            </span>
          </v-col>
          <v-col cols="auto" class="ml-8">
            <v-avatar style="margin: auto; display: block;" size="250px" class="elevation-16">
              <v-img :src="erbiImg" alt="Avatar" cover />
            </v-avatar>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- MOBILE TEAM BLOCKS -->
    <v-row justify="center" no-gutters class="d-lg-none ma-2 pa-2">
      <v-col cols="auto">
        <v-img v-if="false" width="100%" style="margin: auto; display: block;" src="@/assets/texts/meet the team.svg" />
      </v-col>
      <v-col cols="12" class="mt-16 text-justify text-body-1 text-white font-italic" style="font-family: Montserrat !important;">
        {{ $t('team.alvaro.text') }}
      </v-col>
      <v-col cols="12" class="mt-8 text-center">
        <span class="font-weight-bold" style="color: #052A59; font-family: Montserrat !important;">
          {{ $t('team.alvaro.presentation') }}
        </span>
      </v-col>
      <v-col cols="12" class="mt-16">
        <v-avatar style="margin: auto; display: block;" size="80px">
          <v-img :src="alvaroImg" alt="Avatar" cover />
        </v-avatar>
      </v-col>
    </v-row>

    <v-row justify="center" no-gutters class="d-lg-none ma-2 pa-2">
      <v-col cols="auto">
        <v-img v-if="false" width="100%" style="margin: auto; display: block;" src="@/assets/texts/meet the team.svg" />
      </v-col>
      <v-col cols="12" class="mt-16 text-justify text-body-1 text-white font-italic" style="font-family: Montserrat !important;">
        {{ $t('team.erbi.text') }}
      </v-col>
      <v-col cols="12" class="mt-8 text-center">
        <span class="font-weight-bold" style="color: #052A59; font-family: Montserrat !important;">
          {{ $t('team.erbi.presentation') }}
        </span>
      </v-col>
      <v-col cols="12" class="mt-16">
        <v-avatar style="margin: auto; display: block;" size="80px">
          <v-img :src="erbiImg" alt="Avatar" cover />
        </v-avatar>
      </v-col>
    </v-row>

    
  </v-container>
</template>

<script setup>
import { ref } from 'vue'

// importa as imagens (evita 404 do "@/...")
import alvaroImg from '@/assets/team/alvaro_new.png'
import erbiImg from '@/assets/team/erbi.jpeg'

// parceiros (quando background !== null, aplica a cor no cartão)
const images = [
  { path: 'conduril.png',           link: null, background: null },
  { path: 'quinta_javali.png',      link: null, background: null },
  { path: 'geonorte.png',           link: null, background: null },
  { path: 'edirio.png',             link: null, background: null },
  { path: '1200px-Logo_gifi_2020.png', link: null, background: null }, // exemplo com bg
  { path: 'Logo-Esquénio---negro.png', link: null, background: null },
  { path: 'mc_logo.png',        link: null, background: null }     // exemplo com bg
]

// índice do carrossel mobile (Vuetify)
const carouselIndex = ref(0)

function connectPartner (link) {
  if (!link) return
  window.open(link, '_blank')
}

function imagePath (file) {
  // garante o path correto no bundle
  return require(`@/assets/portfolio/${file}`)
}

// controla os botões no mobile
function goLeft () {
  carouselIndex.value = (carouselIndex.value - 1 + images.length) % images.length
}

function goRight () {
  carouselIndex.value = (carouselIndex.value + 1) % images.length
}
</script>

<style scoped>
:deep .v-window__controls{
    display: none;
}
.text--link {
  color: #fff;
  text-decoration: underline;
}
</style>
